export const co2 = 'CO<sub style="font-size:x-small">2</sub>';
export const deFootnotesNedc = `Die angegebenen Werte wurden nach dem vorgeschriebenen Messverfahren ermittelt. Es handelt sich um die „NEFZ-${co2}-Werte“ i.S.v. Art. 2 Nr. 1 Durchführungsverordnung (EU) 2017/1153. Die Kraftstoffverbrauchswerte wurden auf Basis dieser Werte errechnet. Die Angaben beziehen sich nicht auf ein einzelnes Fahrzeug und sind nicht Bestandteil des Angebots, sondern dienen allein Vergleichszwecken zwischen verschiedenen Fahrzeugtypen. Die Werte variieren in Abhängigkeit der gewählten Sonderausstattungen. Weitere Informationen zum offiziellen Kraftstoffverbrauch und zu den offiziellen spezifischen ${co2}-Emissionen neuer Personenkraftwagen können dem „Leitfaden über den Kraftstoffverbrauch die ${co2}-Emissionen und den Stromverbrauch neuer Personenkraftwagen“ entnommen werden, der an allen Verkaufsstellen und bei der DAT Deutsche Automobil Treuhand GmbH (www.dat.de) unentgeltlich erhältlich ist.`;
export const deFootnotesWltp = `Die angegebenen Werte wurden nach dem vorgeschriebenen Messverfahren ermittelt. Es handelt sich um „WLTP-${co2}-Werte“ i.S.v. Art. 2 Nr. 3 Durchführungsverordnung (EU) 2017/1153. Die Kraftstoffverbrauchswerte wurden auf Basis dieser Werte errechnet. Der Stromverbrauch wurde auf der Grundlage VO 683/2008/ EG ermittelt. Die Angaben beziehen sich nicht auf ein einzelnes Fahrzeug und sind nicht Bestandteil des Angebots, sondern dienen allein Vergleichszwecken zwischen verschiedenen Fahrzeugtypen. Die Werte variieren in Abhängigkeit der gewählten Sonderausstattungen.`;

export const arabicMessages = {
  'consumption.co2': 'انبعاثات ثاني أكسيد الكربون',
  'consumption.energy': 'استهلاك الطاقة',
  'consumption.fuel': 'استهلاك الوقود',
  'footnotes.local': '',
  'footnotes.wltp': '',
  'footnotes.nedc':
    'تم الحصول على الأرقام الموضحة وفقًا لعملية القياس المحددة. إنها "قيم NEDC CO2" وفقًا للمادة 2 رقم 1 من اللائحة التنفيذية (الاتحاد الأوروبي) 2017/1153. تم حساب أرقام استهلاك الوقود على أساس هذه القيم. تم تحديد الاستهلاك الكهربائي على أساس التوجيه 692/2008 / EC.',
  'footnotes.emissions.appendix':
    'لمزيد من المعلومات حول الاستهلاك الرسمي للوقود وانبعاثات ثاني أكسيد الكربون لسيارات الركاب الجديدة ، يرجى الاتصال بوكيل مرسيدس-بنز المعتمد.',
  'search.input.label': 'مصطلح البحث الخاص بك / OnlineCode',
  'search.result.buy-online': 'اشتر عبر الانترنت',
  'search.results':
    'لم يتم العثور على نتائج لهذا البحث | تم العثور على نتيجة واحده لهذا البحث |  تم العثور على نتيجتان لهذا البحث| تم العثور على هذه النتائج : {count}',
  'search.results.backup': 'لم يتم العثور على نتائج دقيقة. تصفح الصفحات ذات الصلة:',
  'search.results.none.summary': 'لا توجد نتائج بحث متاحة لمصطلح البحث هذا. يرجى المحاولة مرة أخرى بمصطلح مختلف',
  'search.results.count': 'تم العثور على نتيجة واحده لهذا البحث : {count}',
  'search.show-more': 'أظهر المزيد',
  'search.unavailable': 'البحث غير متوفر حاليا',
  'search.result.new': 'جديد',
  'search.result.consumption': 'الاستهلاك',
  'input.placeholder': 'مصطلح البحث الخاص بك / OnlineCode',
  'watch.video': 'شاهد الفيديو',
  'input.recently': 'آخر بحث',
  'input.help.title': 'ما الذي تبحث عنه؟',
  'input.help.text': 'ابحث باستخدام أنواع السيارات وطرازاتها وأكواد التهيئة أو عن ملحقات ومنتجات ومعلومات أخرى',

  'search.result.list': 'قائمة',
  'search.result.grid': 'شبكة',

  // Empty support
  'support.check': 'يرجى التحقق من وجود أخطاء إملائية أو المحاولة مرة أخرى باستخدام مصطلح مختلف.',
  'support.no.results': 'لا توجد نتائج بحث متاحة لمصطلح البحث هذا',
  'support.no.results.term': 'لم يتم العثور على نتائج',
  'support.chat': 'ألا تستطيع إيجاد ما تبحث عنه؟ يرجى استخدام دعم الدردشة عبر ',
  'support.chat.with.us': 'الإنترنت',
};

export const englishMessages = {
  'consumption.co2': `${co2} emissions combined`,
  'consumption.energy': 'Power consumption in combined test cycle',
  'consumption.fuel': 'Fuel consumption combined',
  'footnotes.local': '',
  'footnotes.wltp': '',
  'footnotes.nedc': '',
  'footnotes.emissions.appendix': '',
  'search.input.label': 'Your search term / OnlineCode',
  'search.result.buy-online': 'Buy Online',
  'search.results': 'No results found | {count} Search Result | {count} Search Results',
  'search.results.backup': 'No exact matches found. View related pages:',
  'search.results.count': '{count} Search Results',
  'search.results.none.summary':
    'There are no search results available for this search term. Please try again with a different term.',
  'search.show-more': 'Show more',
  'search.unavailable': 'Search is not currently available.',
  'search.didyoumean': 'Did you mean ',
  'search.result.new': 'New',
  'input.placeholder': 'Your search term / OnlineCode',
  'suggestions.all_search_results': 'All search results',
  'suggestions.all_search_results_for': 'Show all search results for',
  'suggestions.in': 'in',

  all: 'All',
  UCOS: 'Used vehicle Online Store',
  PASSENGER_CARS: 'Passenger cars',
  VANS: 'Vans',
  NCOS: 'New vehicle Online Store',
  VIDEO: 'Videos',
  DEALER_LOCATOR: 'Dealer search',
  CONFIGURATOR: 'Configurator',
  TEST_DRIVE: 'Test drive',
  VEHICLE_SEARCH: 'Used Cars',
  COLLECT: 'Collection & Accessories',
  CONNECT: 'Mercedes me Store',
  ACCESSORIES: 'Car Accessories',

  'search.result.consumption': 'Consumption',
  'watch.video': 'Watch the video',
  'input.recently': 'Recently Searched',
  'input.help.title': 'What should you look for?',
  'input.help.text':
    'Search using vehicle types, models, configuration codes or for ACCESSORIES, other products and information',

  'carousel.test_drive': 'Buchen Sie eine Probefahrt',
  'search.result.list': 'List',
  'search.result.grid': 'Grid',

  // Empty result
  'support.check': 'Please check for typos or try again with a different term.',
  'support.no.results': 'There are no search results available for this search term.',
  'support.no.results.term': 'No results found',
  'support.chat': "Can't find what you're looking for? Please use our ",
  'support.chat.with.us': 'Online Chat Support',

  'search.results.offer': 'Popular offers for "{query}":',
};

export const germanMessages = {
  'consumption.co2': `${co2}-Emissionen kombiniert`,
  'consumption.energy': 'Stromverbrauch',
  'consumption.fuel': 'Kraftstoffverbrauch kombiniert',
  'footnotes.local': '',
  'footnotes.wltp': '',
  'footnotes.nedc': '',
  'footnotes.emissions.appendix': '',
  'search.input.label': 'Ihr Suchbegriff / Configurator OnlineCode / Model Series / Baumuster',
  'search.result.buy-online': 'Online kaufen',
  'search.results': 'Kein Suchergebnis gefunden | {count} Suchergebnis | {count} Suchergebnisse',
  'search.results.backup': 'Keine genauen Übereinstimmungen gefunden. Verwandte Seiten ansehen:',
  'search.results.count': '{count} Suchergebnisse:',
  'search.results.offer': 'Beliebte Angebote für "{query}":',
  'search.results.none.summary':
    'Es gibt keine Suchergebnisse für diesen Begriff. Bitte versuchen Sie es erneut mit einem anderen Suchbegriff.',
  'search.show-more': 'Mehr anzeigen',
  'search.unavailable': 'Suche ist derzeit nicht verfügbar.',
  'search.result.new': 'Neu',
  // change this
  'input.placeholder': 'Ihr Suchbegriff / Configurator OnlineCode',
  // new part
  'suggestions.all_search_results': 'Alle Suchergebnisse',
  'suggestions.all_search_results_for': 'Alle Ergebnisse anzeigen für',
  'suggestions.in': 'in',

  all: 'Alle',
  UCOS: 'Gebrauchtwagen Online Store',
  PASSENGER_CARS: 'PKW',
  VANS: 'Vans',
  NCOS: 'Neuwagen Online Store',
  VIDEO: 'Videos',
  DEALER_LOCATOR: 'Händlersuche',
  CONFIGURATOR: 'Konfigurator',
  TEST_DRIVE: 'Probefahrt',
  VEHICLE_SEARCH: 'Gebrauchtfahrzeugsuche',
  COLLECT: 'Collection & Zubehör',
  CONNECT: 'Mercedes me Store',
  didyoumean: 'Meinten Sie',
  ACCESSORIES: 'Technisches Zubehör',

  'search.result.consumption': 'Verbrauch',
  'watch.video': 'Das Video anschauen',
  'input.recently': 'Kürzlich gesucht',
  'input.help.title': 'Wonach sollten Sie suchen?',
  'input.help.text':
    'Suche unter Verwendung von Fahrzeugart, Modell, Konfigurationscodes oder nach Zubehör, anderen Produkten und Informationen',

  'carousel.test_drive': 'Buchen Sie eine Probefahrt',
  'search.result.list': 'Liste',
  'search.result.grid': 'Raster',

  // Empty page
  'support.check': 'Bitte prüfen Sie auf Tippfehler oder versuchen Sie es noch einmal mit einem anderen Begriff.',
  'support.no.results': 'Es sind keine Suchergebnisse für diesen Suchbegriff vorhanden.',
  'support.no.results.term': 'Keine Ergebnisse gefunden',
  'support.chat': 'Sie finden nicht, wonach Sie suchen? Bitte nutzen Sie unseren ',
  'support.chat.with.us': 'Online-Chat-Support',
};

export const croatianMessages = {
  'consumption.co2': `${co2} emisije kombinovano`,
  'consumption.energy': 'Potrošnja energije u kombinovanom ciklusu ispitivanja',
  'consumption.fuel': 'Kombinovana potrošnja goriva',
  'footnotes.local': '',
  'footnotes.wltp':
    'Navedene vrednosti su određene prema propisanoj metodi merenja. Ovo su „WLTP vrednosti CO₂“ u smislu člana 2 br. 3 Implementacione uredbe (EU) 2017/1153. Vrednosti potrošnje goriva su izračunate na osnovu ovih vrednosti. Potrošnja električne energije je određena na osnovu VO 683/2008/EG. Podaci se ne odnose na jedno vozilo i nisu deo ponude, već služe isključivo u svrhu poređenja između različitih tipova vozila. Vrednosti se razlikuju u zavisnosti od izabrane opcione opreme.',
  'footnotes.nedc':
    'Prikazane vrednosti su dobijene u skladu sa propisanim procesom merenja. One su "NEDC CO2 vrednosti" u skladu sa čl. 2 br. 1 Implementacione uredbe (EU) 2017/1153. Brojke potrošnje goriva su izračunate na osnovu ovih vrednosti. Potrošnja električne energije je određena na osnovu Direktive 692/2008/EC.',
  'footnotes.emissions.appendix':
    'Za više informacija o zvaničnoj potrošnji goriva i emisiji CO2 novih putničkih automobila, obratite se svom ovlašćenom Mercedes-Benz dileru.',
  'search.input.label': 'Vaš termin za pretragu / Konfigurator OnlineCode',
  'search.result.buy-online': 'Kupiti preko interneta',
  'search.results': 'Nema rezultata | {count} rezultat pretrage | {count} rezultata pretrage',
  'search.results.backup': 'Nema tačnih podudaranja. Pogledajte povezane stranice:',
  'search.results.count': '{count} rezultata pretrage',
  'search.results.none.summary':
    'Nema dostupnih rezultata pretrage za ovaj termin za pretragu. Pokušajte ponovo sa drugim terminom.',
  'search.show-more': 'Prikaži više',
  'search.unavailable': 'Pretraga trenutno nije dostupna.',
  'search.result.new': 'Novi',
  'search.result.consumption': 'Spotřeba',
  'watch.video': 'Podívejte se na video',
  'input.recently': 'Nedávno vyhledané',
  'input.help.title': 'Co byste měli hledat?',
  'input.help.text':
    'Vyhledávejte podle typů vozidel, modelů, konfiguračních kódů nebo příslušenství, další produkty a informace',

  'search.result.grid': 'Mreža',
  'search.result.list': 'Popis',

  // Empty page
  'support.check': 'Provjerite pravopisne pogreške ili pokušajte ponovno s drugim izrazom.',
  'support.no.results': 'Nema dostupnih rezultata pretraživanja za ovaj pojam pretraživanja.',
  'support.no.results.term': 'Nema rezultata',
  'support.chat': 'Ne možete pronaći ono što tražite? Molimo koristite našu online-chat-podršku',
  'support.chat.with.us': 'Online Chat Support',

  all: 'Svi',
  UCOS: 'Online trgovina rabljenih vozila',
  PASSENGER_CARS: 'Osobni automobili',
  VANS: 'Kombiji',
  NCOS: 'Online trgovina za nova vozila',
  VIDEO: 'Video zapisi',
  DEALER_LOCATOR: 'Pretraga trgovaca',
  CONFIGURATOR: 'Konfigurirajte svoj automobil',
  TEST_DRIVE: 'Probna vožnja',
  VEHICLE_SEARCH: 'Rabljeni automobili',
  COLLECT: 'Kolekcija i dodaci',
  CONNECT: 'Trgovina Mercedes me',
  ACCESSORIES: 'Dodatci za auto',
};
